// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"8a54968a","258":"65ff9cec","323":"0f149960","380":"8189d39f","384":"7fb220d9","427":"4c959db0","529":"550aa899","590":"81c8d291","599":"a8375298","663":"c22126fe","747":"df335991","776":"cb310dab","779":"5b2e78e3","895":"69d75bb4","910":"7caaa7c5"}[chunkId] + ".chunk.js";
};